var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import './bounced.css';
var Bounced = /** @class */ (function (_super) {
    __extends(Bounced, _super);
    function Bounced(root) {
        return _super.call(this, "", root, {}) || this;
    }
    Bounced.prototype.errorBounced = function () {
        window.popBox.show("用户名或密码错误。");
    };
    Bounced.prototype.Bounced = function () {
        window.popBox.show("保存成功", //左上方的保存按钮
        { title: "友情提示",
            isConfirmModal: true,
            backdrop: true,
            showHeader: true,
            showFooter: true,
            isActionSheet: false //是否将弹窗样式变成底部弹窗样式. 跟ActionSheet 功能一致
        }).then(function () {
            console.log("确定按钮"); //确定按钮回调
        }, function () {
            console.log("取消按钮"); //取消按钮回调
        });
    };
    Bounced.prototype.Toast = function () {
        window.toast.show("气球提示框"); //过一段时间会自动消失
    };
    Bounced.prototype.ActionSheet = function () {
        window.actionSheet.show("是否删除", ["确定", "取消"]).then(function (n) {
            //底部确定按钮 回调函数会返回点击状态 正确返回正确.错误则返回错误;可在此做业务逻辑处理
            console.log(n);
        });
    };
    Bounced.prototype.LoadingBox = function () {
        window.loadingBox.show(); //加载按钮
        setTimeout(function () { return window.loadingBox.hide(); }, 3000);
    };
    return Bounced;
}(KnockoutModel));
var BouncedModel = /** @class */ (function (_super) {
    __extends(BouncedModel, _super);
    function BouncedModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BouncedModel.prototype.init = function () {
        this.hm = new Bounced(this.container);
        this.hm.bind();
    };
    return BouncedModel;
}(Page));
export default BouncedModel;
